<script setup lang="ts">
import {useFetchGeneral} from '~/api/service/general/index.service'
import HomeChartTitle from '~/components/@pages/home/HomeChartTitle.vue'
import BarChart from '~/components/chart/BarChart.vue'
import LineChart from '~/components/chart/LineChart.vue'
import CustomSuspense from '~/components/suspense/CustomSuspense.vue'
import IconTooltip from '~/components/tooltip/IconTooltip.vue'
import {HOME_CHART_TOOLTIP} from '~/constants/general.const'
import {IMAGE_BASE_URL} from '~/constants/image.constant'
import {generalParamType} from '~/types/general.type'

const {data, isLoading} = useFetchGeneral([generalParamType.CREATE_ACCOUNT])

const isIncreased = computed(() => {
  return parseFloat(data.value!.FACI.OBJ.CNGP) > 0
})

const barChartList = computed(() => {
  if (!data.value) return []
  return data.value.FACI.OBJ.DCALIST.map(i => {
    return [i.UT, i.CNT]
  })
})
</script>

<template>
  <div>
    <CustomSuspense :is-loading="isLoading">
      <template #loading>
        <img
          :src="`${IMAGE_BASE_URL}/skeleton/home/progress-bar.png`"
          alt="claim event skeleton"
        >
      </template>
      <template #default>
        <Card class="p-5">
          <div class="flex flex-col gap-y-2">
            <HomeChartTitle
              title="New Accounts Created"
              :tooltip="HOME_CHART_TOOLTIP[generalParamType.CREATE_ACCOUNT]"
            />
            <strong class="text-3xl font-bold text-primary">
              {{ setComma(data.FACI.OBJ.PTCACNT) }}
            </strong>
          </div>
          <BarChart
            class="mt-4"
            :data="barChartList"
            color="#ad3df9"
            :formatter="(params) => {
              return `<p class='text-center'><span class='text-primary/40'>${params.name}</span><br />Account:
          ${setComma(params.value)}</p>`
            }"
            :height="160"
          />
          <!--          <LineChart-->
          <!--            :height="144"-->
          <!--            line-color="#ad3df9"-->
          <!--            gradient-color="#ad3df9"-->
          <!--            :data="data.FACI.OBJ.DCALIST.map(account => [account.UT, account.CNT])"-->
          <!--            :formatter="(params) => {-->
          <!--              return `<p class='text-center'>${params.name}<br />Account: ${setComma(params.value)}</p>`-->
          <!--            }"-->
          <!--          />-->
        </Card>
      </template>
    </CustomSuspense>
  </div>
</template>

<style scoped>

</style>